import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M23.641 18.485L14.732 1.643a3.093 3.093 0 00-5.464 0L.36 18.485A3.079 3.079 0 003.092 23h17.816a3.079 3.079 0 002.733-4.515zM12.001 20a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm1-5h-2l-.5-8h3l-.5 8z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }